import React from 'react'
import { motion } from 'framer-motion'
import { FiHome, FiUsers, FiCalendar, FiTarget, FiActivity, FiLogOut, FiMail, FiAward, FiX } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'

const Sidebar = ({ activeTab, setActiveTab, isOpen, onClose }) => {
  const navigate = useNavigate()

  const navItems = [
    { id: 'dashboard', label: 'Dashboard', icon: FiHome },
    { id: 'volunteers', label: 'Volunteers', icon: FiUsers },
    { id: 'cleaning_slots', label: 'Cleaning Slots', icon: FiCalendar },
    { id: 'missions', label: 'Missions', icon: FiTarget },
    { id: 'heritage_places', label: 'Heritage Places', icon: FiTarget },
    { id: 'gallery_items', label: 'Gallery', icon: FiTarget }, // Using FiTarget for now, but will import FiImage
    { id: 'newsletters', label: 'Newsletter', icon: FiMail },
    { id: 'impact_stats', label: 'Impact Stats', icon: FiActivity },
    { id: 'leaderboard', label: 'Leaderboard', icon: FiAward },
  ]

  const handleLogout = () => {
    localStorage.removeItem('admin_token')
    navigate('/admin/login')
  }

  return (
    <>
      {/* Mobile Sidebar Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm md:hidden"
          onClick={onClose}
        />
      )}

      <div className={`w-64 h-screen bg-dark-surface/95 backdrop-blur-xl border-r border-white/10 flex flex-col fixed left-0 top-0 z-50 transition-transform duration-300 md:translate-x-0 ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      }`}>
        <div className="p-6 flex justify-between items-center">
          <h1 className="text-2xl font-bold font-grotesk text-accent-cyan">Admin Panel</h1>
          {/* Close button on mobile */}
          <button 
            onClick={onClose} 
            className="text-gray-400 hover:text-white md:hidden transition"
          >
            <FiX size={20} />
          </button>
        </div>

        <nav className="flex-1 px-4 space-y-2 mt-4 overflow-y-auto">
          {navItems.map((item) => {
            const Icon = item.icon
            const isActive = activeTab === item.id

            return (
              <button
                key={item.id}
                onClick={() => {
                  setActiveTab(item.id)
                  if (onClose) onClose()
                }}
                className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 relative ${
                  isActive
                    ? 'bg-accent-cyan/20 text-accent-cyan'
                    : 'text-gray-400 hover:bg-white/5 hover:text-white'
                }`}
              >
                <Icon size={20} />
                <span className="font-medium">{item.label}</span>
                {isActive && (
                  <motion.div
                    layoutId="sidebar-active"
                    className="absolute left-0 w-1 h-8 bg-accent-cyan rounded-r-full"
                  />
                )}
              </button>
            )
          })}
        </nav>

        <div className="p-4 border-t border-white/10">
          <button
            onClick={handleLogout}
            className="w-full flex items-center space-x-3 px-4 py-3 text-red-400 hover:bg-red-400/10 rounded-lg transition-all"
          >
            <FiLogOut size={20} />
            <span className="font-medium">Logout</span>
          </button>
        </div>
      </div>
    </>
  )
}

export default Sidebar
